if (!Array.prototype.indexOf) {
  Array.prototype.indexOf = function(searchElement, fromIndex) {

    var k;

    // 1. Let o be the result of calling ToObject passing
    //    the this value as the argument.
    if (this == null) {
      throw new TypeError('"this" is null or not defined');
    }

    var o = Object(this);

    // 2. Let lenValue be the result of calling the Get
    //    internal method of o with the argument "length".
    // 3. Let len be ToUint32(lenValue).
    var len = o.length >>> 0;

    // 4. If len is 0, return -1.
    if (len === 0) {
      return -1;
    }

    // 5. If argument fromIndex was passed let n be
    //    ToInteger(fromIndex); else let n be 0.
    var n = fromIndex | 0;

    // 6. If n >= len, return -1.
    if (n >= len) {
      return -1;
    }

    // 7. If n >= 0, then Let k be n.
    // 8. Else, n<0, Let k be len - abs(n).
    //    If k is less than 0, then let k be 0.
    k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

    // 9. Repeat, while k < len
    while (k < len) {
      // a. Let Pk be ToString(k).
      //   This is implicit for LHS operands of the in operator
      // b. Let kPresent be the result of calling the
      //    HasProperty internal method of o with argument Pk.
      //   This step can be combined with c
      // c. If kPresent is true, then
      //    i.  Let elementK be the result of calling the Get
      //        internal method of o with the argument ToString(k).
      //   ii.  Let same be the result of applying the
      //        Strict Equality Comparison Algorithm to
      //        searchElement and elementK.
      //  iii.  If same is true, return k.
      if (k in o && o[k] === searchElement) {
        return k;
      }
      k++;
    }
    return -1;
  };
}

jQuery( function( $ ) {
  $('.gallery').slick( {
    slidesToShow: 1,
    prevArrow : '<button type="button" class="slick-prev"></button>',
    nextArrow : '<button type="button" class="slick-next"></button>',
  } );
} );

jQuery( function( $ ) {
  $( '.pvo-product .product-col-bijlagen .product-col-bijlagen-header' ).click( function() {
    var $this = $(this),
        $bijlagen = $this.closest( '.product-col-bijlagen' );

    $bijlagen.toggleClass( 'open' );
  } );
} );

jQuery( function( $ ) {
  var changed = false;
  $('select[name="mkm_productfamilie"]').on( 'change', function() {
    var $this = $(this),
        $form = $this.closest('form'),
        $vervallenH = $form.find('[type="hidden"][name="inclusief_vervallen"]'),
        $vervallenCB = $form.find('[type="checkbox"][name="inclusief_vervallen"]');

    if( $this.find(':selected').closest('optgroup[data-inclusief_vervallen]').length ) {
      if ( ! $vervallenCB.is(':checked') ) {
        changed = true;
        $vervallenCB.prop({checked: 'checked'});
      }

      $vervallenH.val( 1 );
      $vervallenCB.prop({disabled:'disabled'});
    } else {
      $vervallenCB.prop({disabled:''});
      $vervallenH.val( 0 );

      if ( changed ) {
        $vervallenCB.prop({checked: ''});
      }
    }

  } ).trigger('change');
} );
